import { ContentEditable } from "@lexical/react/LexicalContentEditable";
import { memo } from "react";
import styles from "./LexicalContentEditable.module.css";

export const LexicalContentEditable = memo(() => {
  return <ContentEditable className={styles.contentEditable} />;
});
LexicalContentEditable.displayName = "LexicalContentEditable";
